import { Button } from '@components/index';
import { Theme } from '@mui/material';
import { getTypographyVariants } from '@theme/styleOverrides/typography';
import { Link, useSearchParams } from 'react-router-dom';

export type AdditionalInfoLinkProps = {
  text: string;
  url: string;
};

const getUrlType = (link: AdditionalInfoLinkProps) => {
  if (!link) {
    return null;
  }
  const { url } = link;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return 'external';
  }

  if (url.startsWith('?')) {
    return 'query';
  }

  return 'in-app';
};

export const AdditionalInfoLink = (link: AdditionalInfoLinkProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlType = getUrlType(link);

  switch (urlType) {
    /* FUTURE: text button cleanup (shouldn't have to important)
    make size=small actually do something, leaving here for future */
    case 'external':
      return (
        <Button size='small' href={link.url} target='_blank' variant='text' sx={buttonStyles}>
          {link.text}
        </Button>
      );
    case 'query':
      return (
        <Button
          size='small'
          onClick={() => {
            const params = new URLSearchParams(link.url);
            params.forEach((value, key) => {
              searchParams.set(key, value);
            });
            setSearchParams(searchParams, { replace: true });
          }}
          variant='text'
          sx={buttonStyles}
        >
          {link.text}
        </Button>
      );
    default:
      return (
        <Link to={link.url} style={{ textDecoration: 'none' }}>
          <Button size='small' variant='text' sx={buttonStyles}>
            {link.text}
          </Button>
        </Link>
      );
  }
};

const buttonStyles = (theme: Theme) => ({
  height: '0px !important',
  margin: '0px !important',
  padding: '0px !important',
  fontSize: getTypographyVariants(theme.palette.fontSize).caption.fontSize,
});
